import React from "react";
import Carousel from "react-elastic-carousel";
import { Menu } from "../rawData/kidsAPI";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import "../css/circle.css";

const arrivalpoint = [
  { width: 1, itemsToShow: 1 },
  { width: 350, itemsToShow: 3 },
  { width: 768, itemsToShow: 3 },
  { width: 1024, itemsToShow: 5 },
];

const NewArrivalCarousel = () => {
  return (
    <>
      <div className=" container cards-container2">
        <div className="mt-4 mb-4">
          <h3 className="text-center  mb-4 mt-4">New Arrivals</h3>
          <Carousel
            itemPadding={[2]}
            itemsToScroll={[1]}
            breakPoints={arrivalpoint}
            renderArrow={({ type, onClick }) => {
              // console.log(type);
              return (
                <div onClick={onClick}>
                  {type === "NEXT" ? (
                    <button className="btnn">
                      <IoIosArrowForward />
                    </button>
                  ) : (
                    <button className="btnn">
                      <IoIosArrowBack />
                    </button>
                  )}
                 
                </div>
                
              );
            }}
          >
            {Menu.map((curElem) => {
              const { id, name, category, image, price } = curElem;
              return (
                <>
                  <div className="card-container" key={id}>
                    <div className="card ">
                      <img src={image} alt="images" className="card-media" />
                      <div className="card-body">
                        <h6 className="card-title"> {name} </h6>
                        <p className="card-text">{category}</p>
                        <span className="card-tag  subtle">{price} </span>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
          </Carousel>
        </div>
      </div>
    </>
  );
};

export default NewArrivalCarousel;
